import React from "react";
import { render, screen, waitFor } from "@testing-library/react";
import "@testing-library/jest-dom";

// pdvEnabled must read workspace.enabled_integrations, fail closed when
// absent/empty/not-containing "pdv". See CompanyProfile.tsx:158.
const mockUseWorkspaceContext = jest.fn();
jest.mock("../../../providers/WorkspaceProvider", () => ({
  useWorkspaceContext: () => mockUseWorkspaceContext(),
}));

jest.mock("react-router-dom", () => ({
  useParams: () => ({ company_id: "company-1" }),
  useNavigate: () => jest.fn(),
  useLocation: () => ({ pathname: "/", search: "", state: null }),
}));

const mockBKGRead = jest.fn().mockResolvedValue({
  _id: "workspace-1/company/company-1",
  value: { name: { value: "Acme Biotech" } },
});
const mockBKGCompanyInvestors = jest.fn().mockResolvedValue({ items: [] });
jest.mock("../hooks", () => ({
  useBKGRead: () => mockBKGRead,
  useBKGCompanyInvestors: () => mockBKGCompanyInvestors,
}));

jest.mock("../utils/profileBackNavigation", () => ({
  COMPANY_PROFILE_BACK_SOURCE: { catalystEvents: "catalyst-events", vcProfile: "vc-profile" },
  VC_PROFILE_BACK_SOURCE: { companyProfile: "company-profile" },
  buildVCHref: () => "/",
  useProfileBackTag: () => ({ from: undefined, inFreshTabContext: false }),
}));

jest.mock("../../../components/Tutorial", () => ({
  useTutorialTarget: () => ({ current: null }),
  useTutorialHint: () => {},
}));

jest.mock("../components/BKGAgent", () => ({
  FloatingChatWidget: () => <div data-testid="floating-chat-widget" />,
}));

jest.mock("../components/CompanyCatalystEvents", () => () => (
  <div data-testid="company-catalyst-events" />
));

jest.mock("../components/PDVCompanyConnections", () => () => (
  <div data-testid="pdv-company-connections" />
));

const CompanyProfile = require("./CompanyProfile").default;

const buildWorkspace = (overrides: Record<string, unknown> = {}) => ({
  id: "workspace-1",
  name: "Workspace",
  ...overrides,
});

describe("CompanyProfile pdvEnabled gate", () => {
  beforeEach(() => {
    jest.clearAllMocks();
    mockBKGRead.mockResolvedValue({
      _id: "workspace-1/company/company-1",
      value: { name: { value: "Acme Biotech" } },
    });
    mockBKGCompanyInvestors.mockResolvedValue({ items: [] });
  });

  it("renders the PDV panel when enabled_integrations includes \"pdv\"", async () => {
    mockUseWorkspaceContext.mockReturnValue({
      workspace: buildWorkspace({ enabled_integrations: ["pdv"] }),
    });

    render(<CompanyProfile />);

    expect(
      await screen.findByTestId("pdv-company-connections"),
    ).toBeInTheDocument();
  });

  it("hides the PDV panel when enabled_integrations is absent", async () => {
    mockUseWorkspaceContext.mockReturnValue({
      workspace: buildWorkspace(),
    });

    render(<CompanyProfile />);

    await waitFor(() => expect(mockBKGRead).toHaveBeenCalled());
    expect(screen.queryByTestId("pdv-company-connections")).not.toBeInTheDocument();
  });

  it("hides the PDV panel when enabled_integrations is empty", async () => {
    mockUseWorkspaceContext.mockReturnValue({
      workspace: buildWorkspace({ enabled_integrations: [] }),
    });

    render(<CompanyProfile />);

    await waitFor(() => expect(mockBKGRead).toHaveBeenCalled());
    expect(screen.queryByTestId("pdv-company-connections")).not.toBeInTheDocument();
  });

  it("hides the PDV panel when enabled_integrations does not include \"pdv\"", async () => {
    mockUseWorkspaceContext.mockReturnValue({
      workspace: buildWorkspace({ enabled_integrations: ["hubspot"] }),
    });

    render(<CompanyProfile />);

    await waitFor(() => expect(mockBKGRead).toHaveBeenCalled());
    expect(screen.queryByTestId("pdv-company-connections")).not.toBeInTheDocument();
  });
});
